export default "__VITE_ASSET__DHFnxvog__"